import { render, staticRenderFns } from "./SubscriptionPlans.vue?vue&type=template&id=358ed6e6"
import script from "./SubscriptionPlans.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports